
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetokonkandarshan() {



    const cardData =
    {
        keyword: ' Pune to Konkan Darshan Cabs',
        heading: 'Mauli Cabs: Pune to Konkan Darshan Cabs',
        headingDescription: 'Mauli Cabs offers comfortable and convenient Pune to Konkan Darshan cabs, ensuring a scenic and memorable journey along the beautiful Konkan coastline. Whether you are visiting historic temples, exploring the region’s natural beauty, or enjoying the serene beaches, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Konkan Darshan.',

        top: 'Top Places to Visit in Konkan with Mauli Cabs',

"topPlaces": [
    {
        "title": "Alibaug Beach",
        "description": "Alibaug Beach is one of the most popular beaches in the Konkan region, known for its clean sands and stunning views of the Arabian Sea. It is an ideal spot for relaxation, water sports, and enjoying beautiful sunsets."
    },
    {
        "title": "Ganpatipule Beach",
        "description": "Ganpatipule Beach is known for its scenic beauty and serene environment. Located near the Ganpatipule Temple, this beach offers crystal-clear waters and a peaceful atmosphere, perfect for unwinding and spiritual experiences."
    },
    {
        "title": "Murud Janjira Fort",
        "description": "Murud Janjira Fort is a historic sea fort located off the coast of Murud. Known for its architecture and historical significance, the fort offers a fascinating glimpse into the region's past and spectacular views from the island."
    },
    {
        "title": "Diveagar Beach",
        "description": "Diveagar Beach is a tranquil and less-crowded beach, offering scenic beauty and peaceful surroundings. It’s perfect for beach lovers and those who want to escape the hustle and bustle of city life."
    },
    {
        "title": "Ratnagiri",
        "description": "Ratnagiri is a coastal city known for its historical significance, stunning beaches, and mangoes. Visitors can explore the Ratnadurg Fort, Bhagwati Mandir, and enjoy the beautiful beaches like Mandvi and Bhatye."
    },
    {
        "title": "Tarkarli Beach",
        "description": "Tarkarli Beach is known for its clean white sand and crystal-clear waters, perfect for water sports such as scuba diving and snorkeling. The beach is located in the Sindhudurg district and offers a peaceful retreat."
    },
    {
        "title": "Sindhudurg Fort",
        "description": "Sindhudurg Fort is a historical fort located on an island in the Arabian Sea, near Malvan. The fort is famous for its stunning architecture and breathtaking views of the surrounding sea, and is an important part of Konkan’s history."
    },
    {
        "title": "Kunkeshwar Temple",
        "description": "Kunkeshwar Temple is a beautiful temple dedicated to Lord Shiva, located on the Konkan coast. It is a peaceful pilgrimage site and offers a serene view of the Arabian Sea."
    },
    {
        "title": "Kashid Beach",
        "description": "Kashid Beach is a pristine beach located near Alibaug. Known for its clean, golden sand and clear waters, the beach is ideal for swimming, beach sports, and enjoying the coastal landscape."
    },
    {
        "title": "Dapoli",
        "description": "Dapoli is a coastal town known for its scenic beauty, serene beaches like Murud and Ladghar, and ancient temples. It is a quiet getaway perfect for nature lovers and those seeking tranquility."
    }
],

"services": [
    {
      "name": "Pune to Konkan Darshan Taxi Services",
      "description": "Experience the scenic beauty of Konkan with our dedicated taxi services from Pune to Konkan. Explore serene beaches, historic temples, and picturesque landscapes while traveling in comfort and safety. Our drivers are well-acquainted with the best routes, ensuring you enjoy a hassle-free and memorable trip."
    },
    {
      "name": "Pune to Konkan Darshan Cab Booking",
      "description": "Booking a cab for your Konkan Darshan journey is quick and easy with our online booking system. We offer a variety of vehicles suitable for both solo travelers and groups. With instant confirmation, you can plan your trip with confidence, knowing that your ride is ready whenever you are."
    },
    {
      "name": "Pune to Konkan Darshan Car Rental",
      "description": "Rent a car for a self-driven experience from Pune to Konkan. Choose from a variety of vehicles ranging from hatchbacks to sedans and SUVs, allowing you to explore Konkan at your own pace. Our rental options come with flexible rental durations and competitive pricing to ensure a smooth journey."
    },
    {
      "name": "Pune to Konkan Darshan Chauffeur-Driven Cabs",
      "description": "For those who prefer a more relaxing journey, our chauffeur-driven cabs are perfect. Enjoy the convenience of a professional driver who knows the region well, allowing you to focus on enjoying the scenic views and historical sites along the Konkan coast."
    },
    {
      "name": "Pune to Konkan Darshan One-Way Taxi",
      "description": "Our one-way taxi service from Pune to Konkan is designed for those who prefer a simple, one-time journey. Whether you're going for a short trip to visit beaches or temples, our one-way service offers the convenience of direct drop-off without the need for a return journey."
    },
    {
      "name": "Pune to Konkan Darshan Round Trip Cabs",
      "description": "If you're planning to return from Konkan to Pune, our round-trip cab service is ideal. This option includes pick-up and drop-off at your desired locations, ensuring a comfortable and flexible travel experience, whether you're visiting for a weekend getaway or a longer trip."
    },
    {
      "name": "Pune to Konkan Darshan Luxury Taxi",
      "description": "Travel in style and comfort with our luxury taxi service from Pune to Konkan. Whether you're on a honeymoon, family vacation, or a corporate retreat, we provide top-of-the-line vehicles like Mercedes, BMW, and Audi for those who want to experience luxury while exploring the Konkan region."
    },
    {
      "name": "Pune to Konkan Darshan Travel Packages",
      "description": "Our Konkan Darshan travel packages are designed to give you a complete experience of the region. From beach visits to temple tours and sightseeing, we curate packages that suit different budgets and preferences. Enjoy sightseeing, local food, and the best of Konkan in one convenient package."
    },
    {
      "name": "Pune to Konkan Darshan Private Car Hire",
      "description": "For a personalized experience, consider our private car hire service from Pune to Konkan. With a dedicated driver and the flexibility to choose your itinerary, this service is ideal for those who want to explore Konkan at their own pace, visiting specific attractions or taking detours to lesser-known gems."
    },
    {
      "name": "Pune to Konkan Darshan Taxi Charges",
      "description": "Our taxi charges for the Pune to Konkan Darshan trip are transparent and competitive, with no hidden costs. The fare depends on the type of vehicle you choose, the distance covered, and the duration of your trip. We offer affordable pricing for both one-way and round-trip bookings."
    },
    {
      "name": "Pune to Alibaug Beach Taxi",
      "description": "Alibaug Beach is a popular weekend destination for beach lovers, and our taxi service ensures a smooth journey from Pune to Alibaug. Whether you're heading to the beach or exploring nearby attractions, we offer comfortable and affordable transportation to make your trip hassle-free."
    },
    {
      "name": "Pune to Tarkarli Beach Cab Fare",
      "description": "Tarkarli Beach is known for its pristine waters and scenic views. Our cab service from Pune to Tarkarli offers affordable fares with comfortable seating and experienced drivers, making it an excellent option for those looking for a relaxing beach getaway."
    },
    {
      "name": "Pune to Kashid Beach Cabs",
      "description": "Kashid Beach, located along the Konkan coast, offers a tranquil escape from city life. Our cabs to Kashid Beach ensure a smooth ride with scenic views along the way, perfect for those looking for a peaceful beach vacation."
    },
    {
      "name": "Pune to Malvan Beach Taxi Service",
      "description": "Malvan Beach is a gem of the Konkan region. Book a taxi from Pune to Malvan Beach for a comfortable, scenic journey. Our services are designed to ensure you reach the beach in comfort, offering a stress-free ride for those eager to enjoy the serene coastal environment."
    },
    {
      "name": "Pune to Diveagar Beach Tempo Traveller",
      "description": "For group travel to Diveagar Beach, we offer tempo traveller services. This is an ideal choice for family outings or group vacations, as the spacious vehicle ensures everyone travels comfortably. The ride is both economical and convenient, making it perfect for large groups heading to Diveagar."
    },
    {
      "name": "Pune to Ganpatipule Beach Cab Service",
      "description": "Ganpatipule, known for its scenic beach and the famous Ganesh Temple, is a popular destination for religious and leisure travelers. Our cab services from Pune ensure you arrive in comfort and enjoy the ride as much as the destination itself."
    },
    {
      "name": "Pune to Ratnagiri Cab Service",
      "description": "Ratnagiri is a historic town with beautiful beaches and temples. Whether you're visiting for sightseeing or business, our Ratnagiri cab services offer a convenient and comfortable way to travel from Pune to this beautiful coastal town."
    },
    {
      "name": "Pune to Harihareshwar Beach Taxi Service",
      "description": "Harihareshwar Beach, known for its serenity and religious significance, is easily accessible from Pune with our taxi services. Book a comfortable and affordable taxi to Harihareshwar Beach and experience the spiritual and natural beauty of this hidden gem."
    }
  ],
  "tableData": [
    ["Pune to Konkan Darshan Taxi Services", "Pune to Konkan Darshan Cab Booking"],
    ["Pune to Konkan Darshan Car Rental", "Pune to Konkan Darshan Chauffeur-Driven Cabs"],
    ["Pune to Konkan Darshan One-Way Taxi", "Pune to Konkan Darshan Round Trip Cabs"],
    ["Pune to Konkan Darshan Luxury Taxi", "Pune to Konkan Darshan Travel Packages"],
    ["Pune to Konkan Darshan Private Car Hire", "Pune to Konkan Darshan Taxi Charges"],
    ["Pune to Alibaug Beach Taxi", "Pune to Tarkarli Beach Cab fare"],
    ["Pune to Kashid Beach Cabs", "Pune to Malvan Beach Taxi Service"],
    ["Pune to Diveagar Beach Tempo Traveller", "Pune to Ganpatipule Beach Cab Service"],
    ["Pune to Ratnagiri Cab Service", "Pune to Harihareshwar Beach Taxi Service"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Konkan Darshan trip. Our professional drivers ensure prompt pickups and drop-offs, allowing you to experience the beauty of Konkan without any travel-related stress or delays."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Konkan Darshan journey, we offer a variety of comfortable and spacious vehicles. From air-conditioned sedans to SUVs, all our vehicles are well-maintained to provide a smooth and enjoyable ride as you explore the scenic beauty of Konkan."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes for your Pune to Konkan Darshan trip. They ensure a smooth, safe, and comfortable journey, allowing you to enjoy the sights and landmarks of the Konkan region without any worries."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs provides affordable and transparent pricing for your Pune to Konkan Darshan ride. We offer competitive rates with no hidden charges, ensuring that you get the best value for your journey while enjoying a comfortable and safe ride."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and comfortable ride throughout your Konkan Darshan journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Konkan Darshan trip. Whether you're planning an early morning start or a late-night return, our customer service team is always available to assist you with your booking and travel arrangements."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Konkan Darshan cab with Mauli Cabs is quick and hassle-free. You can easily book your ride online via our website or mobile app, or contact our customer service team for personalized assistance, ensuring a seamless booking experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Konkan Darshan trip. Whether you're traveling with family, friends, or as part of a group, we can tailor the service to suit your specific needs and ensure a memorable journey through the stunning Konkan coastline."
    }
]
























    }


    const faqData = [
        {
            question: 'How do I book a cab from Pune to Konkan Darshan with Mauli Cabs?',
            answer: 'Booking a cab for Konkan Darshan from Pune with Mauli Cabs is simple! You can book directly through our website or mobile app by entering "Pune" as your pickup location and "Konkan Darshan" as your destination. Choose your preferred vehicle, confirm the booking, and you’re good to go. Alternatively, you can contact our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Konkan Darshan trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your Pune to Konkan Darshan journey, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select the vehicle based on your space and comfort preferences.',
        },
        {
            question: 'Is the fare for the Pune to Konkan Darshan trip fixed?',
            answer: 'Yes, the fare for the Pune to Konkan Darshan trip is fixed and transparent. The fare includes all charges such as tolls, taxes, driver fees, and other applicable charges. There are no hidden costs, and you will know the total fare upfront at the time of booking.',
        },
        {
            question: 'Can I book a round trip for the Pune to Konkan Darshan journey?',
            answer: 'Yes, you can easily book a round trip from Pune to Konkan Darshan. Simply provide your return details during booking, and we will ensure a smooth return journey for you.',
        },
        {
            question: 'How long does the journey from Pune to Konkan Darshan take?',
            answer: 'The journey from Pune to Konkan Darshan typically takes about 6 to 7 hours, depending on traffic and road conditions. The scenic drive through the Konkan coastline and picturesque villages is sure to enhance your trip experience.',
        },
        {
            question: 'Are the drivers experienced for the Pune to Konkan Darshan trip?',
            answer: 'Yes, all Mauli Cabs drivers are professional, experienced, and familiar with the best routes to Konkan Darshan. They prioritize your safety and comfort and ensure a pleasant and timely journey.',
        },
        {
            question: 'Can I make stops during my journey from Pune to Konkan Darshan?',
            answer: 'Yes, you can make stops during the journey for sightseeing, meals, or refreshments. Our drivers are flexible and will accommodate your requests to ensure a memorable and enjoyable trip.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for the Pune to Konkan Darshan trip?',
            answer: 'Yes, all our cabs are air-conditioned and regularly maintained to ensure a comfortable ride. We prioritize cleanliness and comfort to make sure you have a pleasant journey.',
        },
        {
            question: 'Can I cancel or modify my booking for the Pune to Konkan Darshan trip?',
            answer: 'Yes, you can easily cancel or modify your booking for the Pune to Konkan Darshan trip. We offer flexible cancellation and modification policies through our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Konkan Darshan trip?',
            answer: 'Mauli Cabs offers competitive pricing, a variety of vehicle options, professional drivers, and a commitment to ensuring your safety and comfort. Whether you’re visiting Konkan for pilgrimage, leisure, or a road trip, we ensure a smooth, stress-free, and enjoyable experience.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Amit Joshi",
            position: "Traveler",
            text: "I recently took the Pune to Konkan Darshan trip with Mauli Cabs, and it was one of the best road trips I’ve had. The driver was professional and knowledgeable about the route. The cab was clean, comfortable, and air-conditioned, making the long journey enjoyable. Highly recommended!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Sunita Rao",
            position: "Tourist",
            text: "The Pune to Konkan Darshan trip with Mauli Cabs was amazing. The journey was smooth, and we had some scenic stops along the way. The driver was courteous, and the vehicle was well-maintained. I will definitely book again for my next trip.",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Konkan Darshan Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers reliable and affordable taxi services for your Konkan Darshan trip from Pune. Explore beautiful beaches like Alibaug, Tarkarli, Kashid, Malvan, and Ganpatipule, as well as other Konkan destinations. Choose from chauffeur-driven luxury cabs, one-way or round-trip taxis, and travel packages designed to suit your needs.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
  
      
    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Konkan Darshan Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Konkan Darshan cab with Mauli Cabs. Choose from chauffeur-driven luxury taxis, private car hire, or convenient round-trip options. Explore beaches like Alibaug, Tarkarli, Kashid, and Malvan with ease, while enjoying the beauty of Konkan."
        />
        <meta
          name="keywords"
          content="Pune to Konkan Darshan Taxi Services, Pune to Konkan Darshan Cab Booking, Pune to Konkan Darshan Car Rental, Pune to Konkan Darshan Chauffeur-Driven Cabs, Pune to Konkan Darshan One-Way Taxi, Pune to Konkan Darshan Round Trip Cabs, Pune to Konkan Darshan Luxury Taxi, Pune to Konkan Darshan Travel Packages, Pune to Konkan Darshan Private Car Hire, Pune to Konkan Darshan Taxi Charges, Pune to Alibaug Beach Taxi, Pune to Tarkarli Beach Cab fare, Pune to Kashid Beach Cabs, Pune to Malvan Beach Taxi Service, Pune to Diveagar Beach Tempo Traveller, Pune to Ganpatipule Beach Cab Service, Pune to Ratnagiri cab service, Pune to Harihareshwar Beach Taxi Service"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokonkandarshan;